<template>
  <div class="container">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="消费维度规则" name="expend">
        <ExpendRules  ref="expend"/>
      </el-tab-pane>
      <el-tab-pane label="注册时间规则" name="date">
        <DateRules  ref="date"/>
      </el-tab-pane>
      <el-tab-pane label="活跃度规则" name="activity">
        <ActivityRules  ref="activity"/>
      </el-tab-pane>
      <el-tab-pane label="自定义用户" name="customize">
        <CustomizeUser  ref="customize"/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>

// import { getUserRules } from '@/api/user'
import  ExpendRules from '@/views/ExpendRules.vue'
import  DateRules from '@/views/DateRules.vue'
import  ActivityRules from '@/views/ActivityRules.vue'
import  CustomizeUser from '@/views/CustomizeUser.vue';
export default {
  name: "UserRules",
  components: { ExpendRules,DateRules,ActivityRules,CustomizeUser },
  data() {
    return {
      activeName: 'expend',
    };
  },
  created() {
  },
  computed: {
  },
  methods: {
    handleClick(tab) {
      if (this.$refs[tab.paneName]) {
        this.$nextTick(() => {
          this.$refs[tab.paneName].init()
        })
      }
    },
  }
};
</script>

<style scoped>
.handle-box {
  margin-bottom: 20px;
}

.handle-select {
  width: 120px;
}

.handle-input {
  width: 200px;
  display: inline-block;
}

.table {
  width: 100%;
  font-size: 14px;
}

.red {
  color: #ff0000;
}

.mr10 {
  margin-right: 10px;
}

.table-td-thumb {
  display: block;
  margin: auto;
  width: 40px;
  height: 40px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.el-dialog__body {
  height: 50vh;
  overflow: auto;
}

/deep/.el-tabs__item {
  width: 100px;
  text-align: center;
}

.balance_detail /deep/.el-tabs__item {
  width: 250px !important;
  text-align: left;
}
</style>